import { connect } from 'react-redux';
import FirebaseMessagingProvider from './firebase_messaging_provider';

const mapStateToProps = ({ user }: { user: { user: { id?: number; webPushToken?: string } } }) => ({
  userId: user?.user?.id || null,
  webPushToken: user?.user?.webPushToken || null
});

export default connect(mapStateToProps)(FirebaseMessagingProvider);

export { useNotification } from './useNotification';
export * from './types';
